var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { IThemeRepositoryType } from '../IThemeRepository';
import { IApplicationRepositoryType } from '../../Application/IApplicationRepository';
import { injectable } from '../../../../Data/Decorators/Injectable';
import { inject } from './../../../../Data/Decorators/Inject';
import { hexToRgb } from '../../../../Helpers/Hex/Hex';
import { Platform } from 'react-native';
let GetThemeUseCase = class GetThemeUseCase {
    constructor(repository, applicationRepository) {
        this.repository = repository;
        this.applicationRepository = applicationRepository;
    }
    getValue(componentStyles, keys) {
        let value = componentStyles;
        for (let i = 0; i < keys.length; i++) {
            const key = (keys[i] || '').trim();
            value = (value || {})[key];
            if (!value || typeof value !== 'object') {
                if (i < keys.length - 1) {
                    value = undefined;
                }
                break;
            }
        }
        return value;
    }
    parseStyles(applicationStyle, componentStyle) {
        return Object.entries(componentStyle).reduce((acc, [key, value]) => {
            if (value && typeof value === 'object') {
                acc[key] = this.parseStyles(applicationStyle, value);
            }
            else if (value && typeof value === 'string' && value.includes('.') && !value.startsWith('rgb') && !value.startsWith('https://')) {
                acc[key] = this.getValue(applicationStyle, value.split('.'));
            }
            else {
                acc[key] = value;
            }
            if ((key === 'color' || key === 'backgroundColor') && typeof acc[key] === 'string' && acc[key].startsWith('#')) {
                acc[key] = hexToRgb(acc[key]);
            }
            return acc;
        }, {});
    }
    mergeStyles(base, update) {
        const style = Object.assign({}, base);
        Object.entries(style).forEach(([key, value]) => {
            if (value && typeof value === 'object' && value.fontFamily) {
                if (!this.applicationRepository.hasFont(value.fontFamily) && Platform.OS !== 'web') {
                    style[key] = Object.assign(Object.assign({}, value), { fontFamily: undefined });
                }
            }
        });
        Object.keys(base).forEach((key) => {
            update[key] && Object.entries(update[key]).forEach(([styleKey, value]) => {
                if (value || typeof value === 'number') {
                    style[key][styleKey] = value;
                }
            });
        });
        Object.entries(update).forEach(([key, value]) => {
            if (!style[key]) {
                style[key] = value;
            }
        });
        return style;
    }
    execute(componentStyles, moduleName, componentName) {
        const lowerCaseModuleName = moduleName[0].toLowerCase() + moduleName.slice(1);
        const applicationStylesObs = this.repository.getTheme();
        const componentStylesObs = this.repository.getComponentTheme(lowerCaseModuleName, componentName);
        const configurationStyles = this.parseStyles(applicationStylesObs.value, componentStylesObs.value || {});
        const style = this.mergeStyles(componentStyles, configurationStyles);
        return style;
    }
};
GetThemeUseCase = __decorate([
    injectable(),
    __param(0, inject(IThemeRepositoryType)),
    __param(1, inject(IApplicationRepositoryType)),
    __metadata("design:paramtypes", [Object, Object])
], GetThemeUseCase);
export { GetThemeUseCase };
